<template>
       <div class="posRelative" ref="me">
            <drop 
                @dragenter="handleDragOver"
                @dragleave="handleDragLeave" 
                @drop="doDrop"
                v-show="(!hideMe || !$parent.filterByType)">   
                
                <div :class="{cardDropDragOver: dragging && !$parent.isInbox, cardDropDragOverInbox: dragging && $parent.isInbox, cardDrop: !$parent.isInbox, cardDropInbox: $parent.isInbox}" 
                    :style="[!$root.app.showImages && !$parent.isInbox ? {height: '63px'} : {}]">
                    <div v-show="dragging" class="has-text-white" :class="{'has-text-centered': !$parent.isInbox, 'has-text-left': $parent.isInbox}">
                        <span v-if="$parent.isInbox">&nbsp;&nbsp;</span>
                        <i class="fa fa-file"></i><br v-if="!$parent.isInbox">
                        <i v-if="!$parent.isInbox" class="fa fa-arrow-down"></i>
                        <span v-if="$parent.isInbox">&nbsp;</span><i v-if="$parent.isInbox" class="fa fa-arrow-right"></i>
                    </div>
                </div>

                <div v-show="$parent.inMultiSelect" class="multiCheck">
                    <div class="multiCheckButt" @click="toggleSelected">
                        <i v-show="isSelected" class="fa fa-check fa-4x has-text-white" ></i> 
                    </div>
                </div>
                
               <!--  <div v-if="cardsView"> -->
                    <drag :class="{unselected: $parent.inMultiSelect, wobuCardInbox: $parent.isInbox, wobuCard: !$parent.isInbox, cardReduceSize: dragging && !$parent.isInbox}" :transfer-data="{bundleId: $parent.conts.aliasTgtId || $parent.conts.id, cardId: id, cardsIndex: cardsIndex, type: 'card', parentCollabId: !$parent.isInbox ? $parent.conts.parentCollabId : 'root', isInbox: $parent.isInbox, trueFromBundleId: $parent.conts.id}" @dragstart="dragStart" @dragend="dragEnd" >
                        
                        <a  :href="item.url" target="_blank">
                          
    
                            <div v-if="!item.myCard" class="notMine has-text-centered">
                                <div>{{initials}}</div>
                            </div><!-- <i class="fas fa-copyright is-block left-1"></i> -->
    
                           <!--  <div class="is-size-7 has-background-black has-text-white has-text-centered colorLeft handCursor topRoundCorners" :class="{both: !$root.app.showContext}">
                             
                                <span>{{item.site}}</span>
                              
                            </div> -->
                            <div class="cardImgContainer handCursor" :class="{cardImgContainerHeight: $root.app.showImages}">
                                <img v-show="$root.app.showImages && loaded" :src="item.img || defImg"  @load="imgHasLoaded" @error="imgError">
                                <img v-show="overlay" class="miimuDefOverlaySmall"  :src="overlayImg"/>
                            </div>  
    
                            <rater v-show="$root.app.showImages" :isCollab="$parent.conts.collabId ? true : false" :ratingMy="ratingMy" :topBox="$parent.conts.collabId ? parseFloat(ratingMemAvg) : parseFloat(ratingMy)" :bottomBox="parseFloat(ratingAvg)" v-if=" $root.app.showRatings"></rater> <!-- $parent.conts.collabId && -->
                       
                            <div class="cardTitleBG posRelative" :class="{hiddenImgHeight: !$root.app.showImages}">
                                
                                <div>
                                    <div class="is-inline-block cardTitAndDesc" :class="{cardDownTit: !$root.app.showImages}">
                                        <div class="cardTitle top5">{{item.title || '&nbsp;'}}</div>
                                        <div class="cardDescription">{{item.description || '&nbsp;'}}</div>
                                        <div class="cardDescription has-text-grey">{{item.site || '&nbsp;'}}</div>
                                    </div>
        
                                    <div v-if="menuVisible" class="cardMenu ">
                                        <div class="bundleMenuItem" @click="edit(false, $event)">
                                            <i class="fa fa-info-circle is-size-6 handCursor sortControlButt"></i>Details
                                        </div>
                                        <div class="bundleMenuItem" @click="shareMiimu($event)">
                                            <i class="fa fa-share is-size-6 handCursor sortControlButt"></i>Share
                                        </div>
                                       
                                        <div v-show="$parent.conts.collabId || parentPublic" class="bundleMenuItem" @click="comments($event)">
                                            <i class="fa fa-comment is-size-6 handCursor sortControlButt"></i>Comments
                                        </div>
                                        <div class="bundleMenuItem" @click="del(item.id, $event)">
                                            <i class="fa fa-trash is-size-6 handCursor sortControlButt"></i>Delete
                                        </div>
                                       
                                    </div>
            
                                    <div class="is-inline-block vTop" @click.prevent="showMenu" >
                                        <div class="cardVEllipsis" :class="{cardDownTit: !$root.app.showImages}"><b>&vellip;</b></div>
                                    </div>
                                </div>
        
                               <!--  <div class="has-text-right right4">
                                    <div class="cardSocialIcon" v-html="source"></div>
                                    <div class="roundButton has-background-coolGreen top5 bottom10 has-text-centered" ><i class="fa fa-link has-text-white"></i></div>
                                    <div class="roundButton has-background-grey top5 bottom10 has-text-centered" @click="edit"><i class="fa fa-pen has-text-white"></i></div>
                                </div> -->
                            </div> 
                        </a>
                      
                    </drag>
                    
                    <div v-if="!$parent.isInbox && $root.app.showContext && item.note" class="cardContext " :class="{cardContextNoImages: !$root.app.showImages}">
                        <i style="font-size:.6rem" class="fa fa-pen has-text-coolGreen is-pulled-right top-2 right2 handCursor" @click="edit(true, $event)"></i><br>
                        <div v-linkified class="cardContextNote has-text-left" style="overflow: auto" v-html="item.note"></div>
                    </div>
                   <div v-if="!$parent.isInbox && $root.app.showContext && !item.note" class="cardContextEmpty" :class="{cardContextNoImages: !$root.app.showImages}">
                        <i style="font-size:.6rem" class="fa fa-pen has-text-coolGreen is-pulled-right top-2 handCursor closedNotePen" @click="edit(true, $event)"></i><br>
                    </div>

                    <ad v-if="hasAd && $root.app.showAds" class="is-inline-block"></ad>


                <!-- </div> -->
    
            <!--     <div v-if="!cardsView">
                   <div class="urlCardLineView">
                       <img v-show="loaded" :src="item.img || defImg"  @load="imgHasLoaded" width="70">
                       <div class="urlCardLineTitle">{{item.title || '&nbsp;'}}</div>
                   </div>
                </div> -->
            </drop>
            <div v-if="hideMe && $parent.filterByType">
               <div class="miimuGhost">
                   <div class="mGhostImg">&nbsp;</div>
                   <div class="mGhostInfo is-inline-block is-size-6">
                       <div class="mGhostTitle">
                           &nbsp;
                       </div>
                       <div class="mGhostDesc">
                           &nbsp;
                       </div>
                   </div>
                   <div class="is-inline-block mGhostEllipsis" >
                       <div class="mGhostElliDiv">
                           &nbsp;
                       </div>
                   </div>
               </div>
            </div>
       </div>
</template>

<script>
import { Drag, Drop } from 'vue-drag-drop'
import { AZEventBus } from '../components/AZEventBus'
import Rater from './Rater.vue'
import Ad from './Ad.vue'
import defImages from '../static/defimages'


function getRelativeCoordinates (event, element){

    const position = {
        x: event.pageX,
        y: event.pageY
    };

    const offset = {
        left: element.offsetLeft,
        top: element.offsetTop
    };

    let reference = element.offsetParent;

    while(reference != null){
        offset.left += reference.offsetLeft;
        offset.top += reference.offsetTop;
        reference = reference.offsetParent;
    }

    return { 
        x: position.x - offset.left,
        y: position.y - offset.top,
    }; 
}

export default {
    name: 'url-card',
    components: {Drag, Drop, Rater, Ad},
    props: {
        id: Number,
        p: Number,
        //listIndex: Number,
        itemIndex: Number,
        theCardsIndex: Number,
        currImg: String,
        defImages: defImages,

    },
    data: function(){
        return {
            dragging: false,
            loaded: false,
            cardsView: true,
            menuVisible: false,
            counter: 0,
            disp: null,
            overlayImg: '',
            dummy: 1,
            isSelected: false,
            parentPublic: this.$parent.data.isPublic ? true : false,
            hasAd: false,
            inboxWasOpen: undefined
        }
    },
    mounted: function(){

        if(this.itemIndex % this.$parent.adFreq == 0 && this.itemIndex > 0) 
            this.hasAd = true
        
        AZEventBus.$on('closeAllMenus', this.closeAllMenusHandler)
        AZEventBus.$on('cardDragEnd', this.cardDragEndHandler)
        
    },

    beforeDestroy: function(){
        AZEventBus.$off('closeAllMenus', this.closeAllMenusHandler)
        AZEventBus.$off('cardDragEnd', this.cardDragEndHandler)
    },

    methods: {
        closeAllMenusHandler: function(msg){
            this.menuVisible = false
        },

        cardDragEndHandler: function(msg){
            this.counter = 0
            this.dragging = false
        },

        handleDragOver: function(data, event){
         
           event.preventDefault()
           if(data && data.type == 'card'){
                this.counter++;
                this.dragging = true;
           }
        },
        handleDragLeave: function(event){
            //event.stopPropagation()
            this.counter--
            if(this.counter == 0){
                this.dragging = false
            }
        },
        edit: function(goToNotes, e){
            document.activeElement.blur()
            e.stopPropagation()
            e.preventDefault()
            this.$root.app.doShowModal('editModal', {url: '', cardsIndex: this.cardsIndex, callApi: false, caller: this, bundleId: this.$parent.conts.aliasTgtId || this.$parent.conts.id, collabIdFromUrlCard: this.$parent.conts.collabId, goToNotes: goToNotes, parentPublic: this.parentPublic})
        },
        comments: function(e){
            e.preventDefault()
            this.$root.app.doShowModal('editModal', {url: '', cardsIndex: this.cardsIndex, callApi: false, caller: this, bundleId: this.$parent.conts.aliasTgtId || this.$parent.conts.id, collabIdFromUrlCard: this.$parent.conts.collabId, goToComments: true, parentPublic: this.parentPublic})
        },
        shareMiimu: function(e){
            e.preventDefault()
            this.$root.app.doShowModal('shareMiimu', {id: this.item.id})
        },
        doDrop: function(data, event){

            
  
            if(this.inboxWasOpen){
                if(!this.$parent.$parent.inbox){
                    this.$parent.$parent.toggleInbox()
                    this.inboxWasOpen = true
                }
            }
            
            //event.preventDefault()
            


            let fromBundleId = data.bundleId
            let cardId = data.cardId
            let cardsIndex = data.cardsIndex
            let toBundleId = this.$parent.conts.id
            let before;
            let after;

            //* Get entryId of neighbours from parent.conts.items
            if(this.$parent.conts.items[this.itemIndex -1] != undefined)
                before = this.$parent.conts.items[this.itemIndex -1].entryId
            else 
                before = false

            after = this.$parent.conts.items[this.itemIndex].entryId || false;

            if((this.$root.app.cards[data.cardsIndex].id_cog != this.$root.app.userAttrs.sub) && (data.parentCollabId != (this.$parent.isInbox ? 'root' : this.$parent.conts.parentCollabId)) ){
                this.$root.app.showModalOK({message: 'This card was not contributed to this collaboration by you. You cannot move it outside this collab bundle. Make a copy instead?', 
                                            callBack: this.$root.app.copyCardCallback, 
                                            payload: {url: '', cardsIndex: data.cardsIndex, callApi: false, caller: this, bundleId: this.$parent.conts.id, before: before, after: after, fromBundleId: data.trueFromBundleId}})
                this.dragging = false
                return
            } 

            let self = this
            function callBack(){
                self.$parent.sort()
                self.dragging = false
            }

            this.$root.app.cardMover(fromBundleId, cardId, toBundleId, before, after, this.$root.app, callBack, cardsIndex, this.$parent.conts.aliasTgtId)

            AZEventBus.$emit('cardDragEnd', {})

        

        },
        

        imgHasLoaded: function(data){
            this.loaded = true;
            this.dragging = false;
            //remove
        },
        go: function(url){
            window.open(url)
        },
        del: function(id, e){
            e.preventDefault()

            if(!this.item.myCard){
                this.$root.app.showModalOK({message: 'You may not delete a card contributed by someone else.'})
                return
            }

            this.$root.app.doShowModal('modalDeleteCard', {id: id, callBack: this.doDel})
        },
        doDel: function(selected, id){
            
             var self = this;

             var card = this.$root.app.cards.find((e) => {
                 return e.id == id
             })

            var cardParents = card.parents

            var theB = self.$parent.conts.aliasTgtId || self.$parent.conts.id
            var tgtParent = cardParents.find((e) => {
                return e.id == theB
            })
           
            var entryId = tgtParent.entryId

            function w(data){
                az.addRemSpinner(false, 'id', 'delButt');
                
                if(data.response == 'ok'){
                   
                    if(selected == 'curr'){
                        var index = self.$root.app.bundles.findIndex(e => {
                            return e.id == self.$parent.conts.id
                        })

                        var i = self.$root.app.bundles[index].items.findIndex(e => {
                            return e.id == id
                        })
                    
                        //remove from bundle.items
                        self.$root.app.bundles[index].items.splice(i, 1)

                        //remove from cards.parents
                        let theId = self.$parent.conts.id
                        //let pars = cardParents
                        let ind = cardParents.findIndex(e => {
                            return e.id == theId
                        })
                        cardParents.splice(ind, 1)

                        if(data.foundADirty){
                            self.$root.app.bundles[index].dirt -= 1;
                            self.$root.app.checkForRootDirtAlert(self.$parent.conts.id)
                        }
                    } else if(selected == 'all'){
                        //remove from each bundle items
                       
                        for(var x=0; x < cardParents.length; x++){

                            var dex = self.$root.app.bundles.findIndex(e => {
                                 return e.id == cardParents[x].id
                            })

                            var t = self.$root.app.bundles[dex].items.findIndex(e => {
                                return e.id == id
                            })
                            self.$root.app.bundles[dex].items.splice(t, 1)

                            //TODO must fix the below so that it only decrements if the card being deleted was dirty in the bundle containing it!!

                           /*  if(self.$root.app.bundles[dex].beenShared){
                                self.$root.app.bundles[dex].dirt -=1;
                                self.$root.app.checkForRootDirtAlert(self.$root.app.bundles[dex].id)
                            } */
                        }

                        //blank out parents array
                        //cardParents.splice(0)
                    }
                   
                }
                self.$root.app.closeModal()
            }

            function n(){
                az.addRemSpinner(false, 'id', 'delButt');
                self.$emit('close')
                self.$root.app.showModalOK({message: 'There was an error processing your request, please try again or contact support.'})
            }

            az.addRemSpinner(true, 'id', 'delButt');
            this.$root.app.apiClient.delete('subs/data/card', {entryId: entryId, cardId: id, selOption: selected, bundId: this.$parent.conts.aliasTgtId || this.$parent.conts.id, beenShared: this.$parent.conts.beenShared}, w, n);
        },
        dragStart: function(data, e){
            
            
            this.inboxWasOpen = this.$parent.$parent.inbox

            
            
            if(this.$parent.$parent.inbox){
                this.$parent.$parent.toggleInbox()
                this.inboxWasOpen = true
            }

            if(this.itemIndex > 0 && this.hasAd){
                this.$parent.data.items[this.itemIndex - 1].hasAd = true
            }
            this.hasAd = false
          
            var img = this.$refs.me//document.getElementById('dragger')
            e.dataTransfer.setDragImage(img, 0, 0);
           
        
        
            /* 
            var crt = e.target.cloneNode(true);
            crt.setAttribute("id", "crt");
            crt.getElementsByTagName('img')[0].setAttribute('src', crt.getElementsByTagName('img')[0].src)
            document.body.appendChild(crt); */

            //e.dataTransfer.setDragImage(crt, 0, 0);
        },
        showMenu: function(event){
            event.stopPropagation()
            this.menuVisible = true
        },
        navigate: function(e){
            e.stopPropagation()
            window.open(this.item.url);
        },

        forceUpdate: function(){
            this.$forceUpdate();
        },
        imgError: function(){
            this.item.img = this.defImg
        },

        toggleSelected: function(){
            this.isSelected = !this.isSelected
            if(this.isSelected){
                this.$parent.addToMulti(this.item)
            } else {
                this.$parent.removeFromMulti(this.item)
            }
        },

        dragEnd: function(){
            if(this.inboxWasOpen){
                if(!this.$parent.$parent.inbox){
                    this.$parent.$parent.toggleInbox()
                    this.inboxWasOpen = true
                }
            }
        }

        /* ,
        onWaypoint ({ going, direction }) {
            // going: in, out
            // direction: top, right, bottom, left


            if (going === this.$waypointMap.GOING_IN) {
                this.showing = true
            } else if(going === this.$waypointMap.GOING_OUT){
                this.showing = false
            }

        } */
        
    },
    computed: { 
        item: function(){ 
           var temp = this.$root.app.cards[this.cardsIndex]; 
           if(temp.note)
            temp.note = temp.note.split('<').join('&lt;')
           return  temp || {title: '', site: '', cardsIndex: ''};
        },
        ratingMy: function(){
            if(!this.item.myRatings){
                return 0
            }
            //var theId = this.$parent.conts.collabId ? this.$parent.conts.collabId : this.$parent.conts.id;
            var theId = this.$parent.conts.aliasTgtId ? this.$parent.conts.aliasTgtId : this.$parent.conts.id;
            let r = this.item.myRatings.find(e => {
                return e.collabId == theId
            })  
           

            if(r){
                return r.rating
            } else {
                return 0
            } 
        },
        ratingAvg: function(){
            if(!this.item.avgRatings){
                return 0
            }
            var theId = this.$parent.conts.aliasTgtId ? this.$parent.conts.aliasTgtId : this.$parent.conts.id;
            let r = this.item.avgRatings.find(e => {
                return e.collabId == theId
            })

            if(r){
                return r.rating
            } else {
                return 0
            } 
        },
        ratingMemAvg: function(){
            if(!this.item.avgMemRatings){
                return 0
            }
            var theId = this.$parent.conts.aliasTgtId || this.$parent.conts.id;
          
            let r = this.item.avgMemRatings.find(e => {
                return e.collabId == theId
            })

            if(r){
                return r.rating
            } else {
                return 0
            } 
        },
        cardsIndex: {
            get: function(){
                return this.theCardsIndex
            },

            set: function(newVal){
               
            }   
        },
        defImg: function(){
            return `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-default.png`;
        },
        overlay: function(){

            var temp = az.overlaySorter(this.item.site, this.item.url, this.item.img)
            this.overlayImg = defImages.overlays[temp]
            return temp

           /*  if(this.item.img.substring(0, 46) == 'https://miimuimg.s3.amazonaws.com/m-ii-default'){
                this.overlayImg = ''
                return false
            } else if(this.item.img.substring(0, 43) == 'https://miimuimg.s3.amazonaws.com/m-ii-BGbg'){
               
                var temp = az.overlaySorter(this.item.site, this.item.url, this.item.img)
                this.overlayImg = defImages.overlays[temp]
                return temp
            }

            return false */
        },
        /* source: function(){
           return this.$root.app.sourceIcon(this.item.site)
        }, */
        initials: function(){
            var val = this.item.id_cog
            for(var i=0; i < this.$root.app.groupMembers.length; i++){
                if(this.$root.app.groupMembers[i].id_customer == val){
                    return this.$root.app.groupMembers[i].fName.charAt(0).toUpperCase() + this.$root.app.groupMembers[i].lName.charAt(0).toUpperCase()
                }
            }
            return ""
        },

        hideMe: function(){
            return az.overlaySorter(this.item.site, this.item.url) != this.$parent.filterByType
        },

        
    }

}
</script>